import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const DatapointWrapper = styled.div`
    display: flex;
    flex-direction: row;
`;

export const LabelWrapper = styled.div<{ $isUppercase?: boolean }>`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    ${({ $isUppercase }) =>
        $isUppercase &&
        css`
            text-transform: uppercase;
        `}
`;

export const StandingsLegendTitle = styled.h5`
    color: ${({ theme }) => theme.Text.primary};
    margin: 0;
`;

export const LegendBodyWrapper = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.body2}
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    padding-left: 24px;
    margin-top: 16px;
`;

export const LegendColumn = styled.div`
    width: 400px;
    max-width: 400px;
    flex-direction: column;
    align-items: flex-start;
`;

export const StandingsLegendWrapper = styled.div`
    margin-bottom: 56px;
`;
